import { AGENCY_INCLUDED_SEATS } from "features/subscriptions/constants";
import useEstimateCreation from "features/subscriptions/datahooks/useEstimateCreation";
import { formatPrice, parseEstimate } from "features/subscriptions/utils";

import Skeleton from "common/components/ui/Skeleton";
import type { Pricing } from "common/types";

import type { ReactNode } from "react";

export default function AgencySeatPricing({
  pricing,
}: {
  pricing: { addon: Pricing; plan: Pricing };
}) {
  const { estimateCreation } = useEstimateCreation({
    pricing,
    quantity: AGENCY_INCLUDED_SEATS,
    isCustomerSubscription: true,
    couponId: undefined,
  });

  let basePriceComponent: ReactNode = <Skeleton className="w-8 h-4" />;
  let pricePerItemComponent: ReactNode = <Skeleton className="w-8 h-4" />;

  if (estimateCreation) {
    const { basePrice, pricePerItem } = parseEstimate(
      estimateCreation.invoice_estimate,
    );
    basePriceComponent = formatPrice(basePrice);
    pricePerItemComponent = formatPrice(pricePerItem);
  }

  return (
    <div className="flex flex-col gap-y-1 lg:gap-y-0.5 max-lg:items-center text-button-xxs lg:text-button-sm max-lg:text-black-500 flex-1">
      <div className="flex gap-x-1">
        {basePriceComponent}
        <span>base - includes {AGENCY_INCLUDED_SEATS} seats</span>
      </div>
      <div className="flex gap-x-1 lg:text-purple-500">
        {pricePerItemComponent}
        <span>/ additional seat</span>
      </div>
    </div>
  );
}
